"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
const wp_query_params = {
  per_page: 5,
  order: "desc",
  orderby: "date"
};
const wp_query = new WP_Query(wp_query_params);
function NewArrivalsGrid() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div data-section-id="103151" className="grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
        {[...Array(5)].map((_, i) => <div key={i} data-index={i} className="flex flex-col gap-3">
            <div className="aspect-[3/4] w-full animate-pulse bg-muted" />
            <div className="flex flex-col gap-1">
              <div className="h-3 w-3/4 animate-pulse bg-muted" />
              <div className="h-3 w-1/4 animate-pulse bg-muted" />
              <div className="h-3 w-1/2 animate-pulse bg-muted" />
            </div>
          </div>)}
      </div>;
  }
  if (error || products.length === 0) {
    return null;
  }
  return <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
      {products.map((product, i) => <div key={product.id} data-index={i} className="group flex flex-col gap-3">
          <div className="relative aspect-[3/4] w-full overflow-hidden bg-black">
            <Link to={product.link} className="absolute inset-0 z-0">
              {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110 group-hover:opacity-80" loading="lazy" /> : <div className="h-full w-full bg-muted" />}
            </Link>

            <div className="absolute right-3 bottom-3 z-10 opacity-0 transition-all duration-500 translate-y-2 group-hover:translate-y-0 group-hover:opacity-100">
              <AddToCartButton productId={product.id} showQuantity={false} text="+" buttonClassName="flex size-10 items-center justify-center rounded-none bg-primary p-0 text-xl font-light text-primary-foreground hover:bg-primary/90 shadow-[0_0_20px_rgba(255,191,61,0.3)]" />
            </div>
          </div>

          <div className="flex flex-col gap-1 text-[10px] tracking-widest uppercase font-sans">
            <Link to={product.link} className="truncate text-foreground font-default text-sm hover:text-primary transition-colors duration-300">
              {product.title}
            </Link>
            <span className="text-foreground font-medium">
              ${product.price?.toFixed(2)}
            </span>
            <span className="text-muted-foreground opacity-60">RITUAL GRADE</span>
          </div>
        </div>)}
    </div>;
}
export default function NewArrivalsGallery() {
  return;
}